import { Message, MessageBox } from "element-ui";

let msg;

/**
 * @param { ...(import("element-ui/types/message").ElMessageOptions | string) } args
 */
const message = (...args) => {
  if (msg) return;
  const duration = typeof args[0] == "object" ? args[0]["duration"] : 500;
  msg = Message.apply(null, args);
  setTimeout(() => {
    msg = null;
  }, duration);
};

const MsgBox = function () {
  return {
    alert: (...args) => {
      MessageBox.alert.apply(null, args);
    },
    close: () => MessageBox.close(),
  };
};

export const messageBox = MsgBox();

export default message;
